export default {
  chapters: 'Главы',
  bookmarks: 'Закладки',
  highlights: 'Заметки',
  bookInfo: 'Информация о книге',
  author: 'Автор',
  title: 'Название',
  page: 'Страница',
  pages: 'страниц',
  chaptersTitle: 'Содержание',
  bookInfoTitle: 'Информация о книге',
  bookmarksTitle: 'Закладки',
  notesTitle: 'Заметки',
  fileName: 'Название файла',
  year: 'Год',
  format: 'Формат',
  fileSize: 'Размер файла',
  loadingBook: 'Загрузка книги',
  textSize: 'Размер текста',
  textColor: 'Цвет фона',
  appearenceTitle: 'Вид',
  viewMode: 'Режим чтения',
  addNote: 'Добавить заметку',
  editNote: 'Редактировать заметку',
  addBookmark: 'Добавить закладку',
  deleteHighlight: 'Удалить выделение',
  default: 'По умолчанию',
  of: 'из',
  onePage: 'Одна страница',
  twoPages: 'Две страницы',
  scrolling: 'Прокрутка',
  zoom: 'Масштабирование',
  found: 'Найдено',
  searchResults: 'результатов поиска',
  searchResult: 'результат поиска',
  searchResultsThanFive: 'результата поиска',
  notFound: 'Не найдено',
  errorInfo: 'Произошла ошибка.',
  closeReaderBtn: 'Вернуться в библиотеку ',
  genres: 'Жанры',

  isbn: 'ISBN',
  annotation: 'Аннотация',
  authors: 'Авторы',
  publisher: 'Издатель',
  series: 'Серии',
  filter: 'Фильтр',
  export: 'Экспорт заметок'
}



// WEBPACK FOOTER //
// ./src/locale/ru-RU/reader.js